import request from '@/utils/request'


// 查询视频列表
export function listCommunityVideo(query) {
  return request({
    url: '/community/admin/community/video/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询视频分页
export function pageCommunityVideo(query) {
  return request({
    url: '/community/admin/community/video/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

export function pageCommunityVideoReply(query) {
  return request({
    url: '/community/admin/community/video/reply/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询视频详细
export function getCommunityVideo(data) {
  return request({
    url: '/community/admin/community/video/detail',
    method: 'get',
    params: data
  })
}


// 修改视频
export function updateCommunityVideo(data) {
  return request({
    url: '/community/admin/community/video/edit',
    method: 'post',
    data: data
  })
}

// 删除视频
export function delCommunityVideo(data) {
  return request({
    url: '/community/admin/community/video/delete',
    method: 'post',
    data: data
  })
}


export function delCommunityVideoReply(query) {
  return request({
    url: '/community/admin/community/video/reply/delete',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}